function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Api from "../ajax/UserGroupApi";
import * as UserGroupNarrowdownModalComponent from "./UserGroupNarrowdownModalComponent";
import IntlMessage from '../commons/Intl';
import { Placeholder, UserGroupMemberSelection, Action } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // グループメンバーモーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 更新
   */

  Mode[Mode["Modify"] = 2] = "Modify";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Modal: null,
      NonTargetUserList: [],
      TargetUserList: [],
      SelectedTargetUserIdList: [],
      SelectedNonTargetUserIdList: [],
      NonTargetSearchText: "",
      TargetSearchText: "",
      ErrorMessages: [],
      NonTargetUserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.None,
      NonTargetUserGroupNarrowdownGroupNamesText: "",
      NonTargetUserGroupNarrowdownSelectedGroupIdList: [],
      NonTargetUserGroupNarrowdownUserIdList: [],
      NonTargetUserGroupNarrowdownModalLeft: 0,
      NonTargetUserGroupNarrowdownModalTop: 0
    };
    Api.GetGroupMemberList(Number(_this.props.groupId), function (data) {
      _this.setState({
        TargetUserList: data.TargetUserIdList,
        NonTargetUserList: data.ChooseableUserIdList,
        ErrorMessages: []
      });
    });
    _this.changePositionOpenNonTargetUserGroupNarrowdownButtonFunction = _this.changePositionOpenNonTargetUserGroupNarrowdownButton.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * 「登録」ボタン押下時の処理を行います。
   */


  _createClass(MainComponent, [{
    key: "onModify",
    value: function onModify() {
      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        var userIds = [];
        this.state.TargetUserList.map(function (x) {
          userIds.push(x.Id);
        });
        this.props.onModify(this.props.groupId, userIds, this.props.updateDateTime);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * 未対象ユーザーグループ絞り込みモーダル開くボタンの位置変更
     */

  }, {
    key: "changePositionOpenNonTargetUserGroupNarrowdownButton",
    value: function changePositionOpenNonTargetUserGroupNarrowdownButton() {
      var btn = $('#OpenNonTargetUserGroupNarrowdown-button');
      var btn_off = btn.offset();

      if (btn && btn_off) {
        var outerHeight = btn.outerHeight(false);

        if (outerHeight) {
          this.setState({
            NonTargetUserGroupNarrowdownModalTop: btn_off.top + outerHeight,
            NonTargetUserGroupNarrowdownModalLeft: btn_off.left
          });
        }
      }
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var modal = $('#UserGroupMemberModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this2.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
      window.addEventListener('resize', this.changePositionOpenNonTargetUserGroupNarrowdownButtonFunction);
      $("#UserGroupMemberModal").on("scroll", this.changePositionOpenNonTargetUserGroupNarrowdownButtonFunction);
    }
    /**
     * コンポーネントが破棄(アンマウント)される前に実行されます。
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.changePositionOpenNonTargetUserGroupNarrowdownButtonFunction);
      $("#UserGroupMemberModal").off("scroll", this.changePositionOpenNonTargetUserGroupNarrowdownButtonFunction);
    }
    /**
     * 未選択の検索テキストを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateNonTargetSearchText",
    value: function updateNonTargetSearchText(e) {
      this.setState({
        NonTargetSearchText: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 対象の検索テキストを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateTargetSearchText",
    value: function updateTargetSearchText(e) {
      this.setState({
        TargetSearchText: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 未対象ユーザーの選択状態を切り替えます。
     *
     * @param m モデル
     */

  }, {
    key: "changeSelectedNonTargetUser",
    value: function changeSelectedNonTargetUser(m) {
      var next = this.state.SelectedNonTargetUserIdList.filter(function (x, _i) {
        return x != m.Id;
      }); //前回と同じ場合は、未選択

      if (next.length == this.state.SelectedNonTargetUserIdList.length) {
        next.push(m.Id);
      }

      this.setState({
        SelectedNonTargetUserIdList: next
      });
    }
    /**
     * 対象ユーザーの選択状態を切り替えます。
     *
     * @param m モデル
     */

  }, {
    key: "changeSelectedTargetUser",
    value: function changeSelectedTargetUser(m) {
      var next = this.state.SelectedTargetUserIdList.filter(function (x, _i) {
        return x != m.Id;
      }); //前回と同じ場合は、未選択

      if (next.length == this.state.SelectedTargetUserIdList.length) {
        next.push(m.Id);
      }

      this.setState({
        SelectedTargetUserIdList: next
      });
    }
    /**
     * 全てのユーザーを会議から削除します。
     */

  }, {
    key: "removeAllUser",
    value: function removeAllUser() {
      var _this3 = this;

      this.state.TargetUserList.map(function (x) {
        _this3.state.NonTargetUserList.push(x);
      });
      this.setState({
        NonTargetUserList: this.state.NonTargetUserList,
        TargetUserList: [],
        SelectedTargetUserIdList: []
      });
    }
    /**
     * 対象のユーザーを会議から削除します。
     */

  }, {
    key: "removeUser",
    value: function removeUser() {
      var _this4 = this;

      var move_users = this.state.TargetUserList.filter(function (x, _i) {
        return _this4.state.SelectedTargetUserIdList.filter(function (y) {
          return x.Id == y;
        }).length > 0;
      });
      move_users.map(function (x) {
        _this4.state.NonTargetUserList.push(x);
      });
      this.setState({
        NonTargetUserList: this.state.NonTargetUserList,
        TargetUserList: this.state.TargetUserList.filter(function (x, _i) {
          return _this4.state.SelectedTargetUserIdList.filter(function (y) {
            return x.Id == y;
          }).length == 0;
        }),
        SelectedTargetUserIdList: []
      });
    }
    /**
     * 対象のユーザーを会議に追加します。
     */

  }, {
    key: "addUser",
    value: function addUser() {
      var _this5 = this;

      var move_users = this.state.NonTargetUserList.filter(function (x, _i) {
        return _this5.state.SelectedNonTargetUserIdList.filter(function (y) {
          return x.Id == y;
        }).length > 0;
      });
      move_users.map(function (x) {
        _this5.state.TargetUserList.push(x);
      });
      this.setState({
        NonTargetUserList: this.state.NonTargetUserList.filter(function (x, _i) {
          return _this5.state.SelectedNonTargetUserIdList.filter(function (y) {
            return x.Id == y;
          }).length == 0;
        }),
        TargetUserList: this.state.TargetUserList,
        SelectedNonTargetUserIdList: []
      });
    }
    /**
     * 全てのユーザーを会議に追加します。
     */

  }, {
    key: "addAllUser",
    value: function addAllUser() {
      var _this6 = this;

      this.state.NonTargetUserList.map(function (x) {
        _this6.state.TargetUserList.push(x);
      });
      this.setState({
        NonTargetUserList: [],
        TargetUserList: this.state.TargetUserList,
        SelectedNonTargetUserIdList: []
      });
    }
    /**
     * 未対象のユーザーグループ絞り込みを開きます。
     */

  }, {
    key: "onOpenNonTargetUserGroupNarrowdown",
    value: function onOpenNonTargetUserGroupNarrowdown(e) {
      if (this.state.NonTargetUserGroupNarrowdownModalMode != UserGroupNarrowdownModalComponent.Mode.None) {
        return;
      }

      e.stopPropagation();
      this.changePositionOpenNonTargetUserGroupNarrowdownButton();
      this.setState({
        NonTargetUserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.Open
      });
    }
    /**
     * 未対象のグループの変更
     */

  }, {
    key: "onChangeNonTargetUserGroupNarrowdown",
    value: function onChangeNonTargetUserGroupNarrowdown(groupNamesText, selectedGroupIdList, userIds, _userKeys) {
      this.setState({
        NonTargetUserGroupNarrowdownGroupNamesText: groupNamesText,
        NonTargetUserGroupNarrowdownSelectedGroupIdList: selectedGroupIdList,
        NonTargetUserGroupNarrowdownUserIdList: userIds
      });
    }
    /**
     * 外枠マウスダウン
     */

  }, {
    key: "onOutSide",
    value: function onOutSide(e) {
      e.preventDefault();
      this.setState({
        NonTargetUserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.None
      });
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "UserGroupMemberModal",
        role: "dialog",
        onClick: this.onOutSide.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "42",
        src: "/assets/img/member.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(UserGroupMemberSelection.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 form-inline select-wrap-top-left"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group col-7"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group-prepend"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group-text"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/search_icon.svg"
      }))), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        maxLength: 50,
        onChange: function onChange(e) {
          return _this7.updateNonTargetSearchText(e);
        },
        value: this.state.NonTargetSearchText,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.SearchWord)
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "selectbox"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        id: "OpenNonTargetUserGroupNarrowdown-button",
        onClick: this.onOpenNonTargetUserGroupNarrowdown.bind(this),
        tabIndex: -1
      }, this.state.NonTargetUserGroupNarrowdownGroupNamesText)), this.state.NonTargetUserGroupNarrowdownModalMode != UserGroupNarrowdownModalComponent.Mode.None && /*#__PURE__*/React.createElement(UserGroupNarrowdownModalComponent["default"], {
        mode: this.state.NonTargetUserGroupNarrowdownModalMode,
        selectedGroupIdList: this.state.NonTargetUserGroupNarrowdownSelectedGroupIdList,
        onChange: this.onChangeNonTargetUserGroupNarrowdown.bind(this),
        top: this.state.NonTargetUserGroupNarrowdownModalTop,
        left: this.state.NonTargetUserGroupNarrowdownModalLeft
      }))), /*#__PURE__*/React.createElement("div", {
        className: "select-wrap-bottom"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.NonTargetUserList.filter(function (x) {
        return x.Name.indexOf(_this7.state.NonTargetSearchText) >= 0;
      }).filter(function (x) {
        return _this7.state.NonTargetUserGroupNarrowdownSelectedGroupIdList.length == 0 ? true : _this7.state.NonTargetUserGroupNarrowdownUserIdList.some(function (z) {
          return z == x.Id;
        });
      }).map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          key: x.Id,
          onClick: _this7.changeSelectedNonTargetUser.bind(_this7, x),
          className: "list-group-item " + (_this7.state.SelectedNonTargetUserIdList.filter(function (y) {
            return y == x.Id;
          }).length > 0 ? "selected" : "")
        }, x.Name);
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-2 btn-area"
      }, /*#__PURE__*/React.createElement("div", {
        className: "btn-group-vertical"
      }, this.state.TargetUserList.length > 0 && /*#__PURE__*/React.createElement("a", {
        className: "btn btn-primary",
        onClick: this.removeAllUser.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/move_left_all.svg"
      })), this.state.TargetUserList.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "btn btn-primary disabled"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/move_left_all.svg"
      })), this.state.SelectedTargetUserIdList.length > 0 && /*#__PURE__*/React.createElement("a", {
        className: "btn btn-primary",
        onClick: this.removeUser.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/move_left.svg"
      })), this.state.SelectedTargetUserIdList.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "btn btn-primary disabled"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/move_left.svg"
      })), this.state.SelectedNonTargetUserIdList.length > 0 && /*#__PURE__*/React.createElement("a", {
        className: "btn btn-primary",
        onClick: this.addUser.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/move_rigth.svg"
      })), this.state.SelectedNonTargetUserIdList.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "btn btn-primary disabled"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/move_rigth.svg"
      })), this.state.NonTargetUserList.length > 0 && /*#__PURE__*/React.createElement("a", {
        className: "btn btn-primary",
        onClick: this.addAllUser.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/move_rigth_all.svg"
      })), this.state.NonTargetUserList.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "btn btn-primary disabled"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/move_rigth_all.svg"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 groupName"
      }, /*#__PURE__*/React.createElement("h4", null, this.props.groupName)), /*#__PURE__*/React.createElement("div", {
        className: "col-12 form-inline select-wrap-top-right"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group col-8"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group-prepend"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group-text"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/search_icon.svg"
      }))), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        maxLength: 50,
        onChange: function onChange(e) {
          return _this7.updateTargetSearchText(e);
        },
        value: this.state.TargetSearchText,
        tabIndex: 103,
        placeholder: intl.format(Placeholder.SearchWord)
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group col-4"
      })), /*#__PURE__*/React.createElement("div", {
        className: "select-wrap-bottom"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.TargetUserList.filter(function (x) {
        return x.Name.indexOf(_this7.state.TargetSearchText) >= 0;
      }).map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          key: x.Id,
          onClick: _this7.changeSelectedTargetUser.bind(_this7, x),
          className: "list-group-item " + (_this7.state.SelectedTargetUserIdList.filter(function (y) {
            return y == x.Id;
          }).length > 0 ? "selected" : "")
        }, x.Name);
      }))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry))))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };